import { Button, Form, Modal, Select } from 'antd';
import React, { FC, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { moveAssetToEquipmentPerStockLocationForSupplier } from '../../thunks/equipment_per_stock_locations_thunks';
import { stockLocationsRestCrudThunksForSupplier } from '../../thunks/stock_locations_thunks';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import ModalFormFooter from '../common/ModalFormFooter';

const TransferToStockLocationPopup: FC<any> = ({
	stockLocations,
	asset,
	onCancel,
	onSuccess,
	fetchStockLocations,
	fetchMultipleStockLocations,
	moveAssetToEquipmentPerStockLocation,
}): React.ReactElement => {
	const [saving, setSaving] = useState(false);

	const handleSubmit = useCallback(
		(values) => {
			setSaving(true);
			moveAssetToEquipmentPerStockLocation(asset.id, values.stockLocationId)
				.then((record) => onSuccess && onSuccess(record))
				.finaly(() => setSaving(false));
		},
		[asset, moveAssetToEquipmentPerStockLocation, onSuccess]
	);

	return (
		<Modal
			visible={true}
			title="Transfer to stock location"
			onCancel={onCancel}
			footer={null}
			closable={true}
		>
			<Form id="transfer-to-sl-form" layout="vertical" requiredMark={false} onFinish={handleSubmit}>
				<Form.Item
					name="stockLocationId"
					label="Stock location"
					rules={[{ required: true, message: 'Stock location is required!' }]}
				>
					<OWAsyncSelect
						stateSlice={stockLocations}
						targetCollectionName="stockLocationDropdown"
						fetchMultiple={(ids, targetCollectionName) => {
							fetchMultipleStockLocations(ids, targetCollectionName);
						}}
						fetchData={(searchText, targetCollectionName) => {
							fetchStockLocations({ name: searchText }, targetCollectionName);
						}}
						renderRecord={(stockLocation) => (
							<Select.Option key={stockLocation.id} value={stockLocation.id}>
								{stockLocation.name}
							</Select.Option>
						)}
					/>
				</Form.Item>
				<ModalFormFooter
					okText="Transfer"
					cancelText="Cancel"
					loading={saving}
					formId="transfer-to-sl-form"
					onCancelClick={onCancel}
				/>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	asset: state.assets.detail,
	stockLocations: state.stock_locations,
});

const mapDispatchToProps = (dispatch) => ({
	fetchStockLocations: (params, targetCollectionName) =>
		dispatch(stockLocationsRestCrudThunksForSupplier.read(params, targetCollectionName)),
	fetchMultipleStockLocations: (ids, targetCollectionName) =>
		dispatch(stockLocationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	moveAssetToEquipmentPerStockLocation: (assetId, toStockLocationId) =>
		dispatch(moveAssetToEquipmentPerStockLocationForSupplier(assetId, toStockLocationId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransferToStockLocationPopup);
